import { combineReducers } from 'redux';

import stagingReducer from './redux/reducers/stagingReducer';
import curriculumReducer from './redux/reducers/curriculumReducer';
import feedbackReducer from './redux/reducers/feedbackReducer';
import soundReducer from './redux/reducers/soundReducer';
import backgroundPaperReducer from './redux/reducers/backgroundPaperReducer';

const sloppyScrollsCombinedReducers = combineReducers({
  staging: stagingReducer,
  curriculum: curriculumReducer,
  feedback: feedbackReducer,
  sound: soundReducer,
  backgroundPaper: backgroundPaperReducer,
});

export default sloppyScrollsCombinedReducers;
